<template>
	<div class="page">
		<header>
			<h1>
				Surface
				<br />Sous-sol
			</h1>
		</header>
		<article>
			<div class="counter">
				<div class="moins" @click="decrement()">-</div>
				<div class="count">
					{{surface_sous_sol}}
					<span>
						m
						<sup>2</sup>
					</span>
				</div>
				<div class="plus" @click="increment()">+</div>
			</div>
		</article>
		<footer>
			<router-link to="/surface" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
			<router-link v-if="ready" to="/finition" class="button medium">
				Niveau de finition
				<i class="fa fa-angle-right"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "Sous-sol",
		components: {},
		data() {
			return {
				ready: true
			};
		},
		computed: {
			surface_sous_sol() {
				return this.$store.state.surface_sous_sol;
			}
		},
		methods: {
			decrement() {
				if (this.surface_sous_sol <= 5) {
					this.$store.commit("setSousSol", 0);
				} else {
					this.$store.commit(
						"setSousSol",
						this.surface_sous_sol - 5
					);
				}
			},
			increment() {
				this.$store.commit("setSousSol", this.surface_sous_sol + 5);
			}
		},
		mounted() {
			this.$store.commit("setTimer", 60);
		}
	};
</script>

<style lang="less">
	.counter {
		display: flex;
		align-items: center;
		.plus,
		.moins {
			font-weight: bold;
			color: black;
			font-size: 180px;
			padding: 50px;
		}
		.count {
			width: 450px;
			height: 450px;
			color: black;
			background: white;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			text-align: center;
			font-size: 180px;
			font-weight: bold;
			line-height: 180px;
			span {
				font-size: 60px;
				padding-left: 20px;
				padding-top: 70px;
			}
		}
	}
</style>